export default __webpack_public_path__ + "static/hackathon-grid-4-3c14bfaf10a3589862202f9d33ddef07.png";